<div class="table-responsive">
    <table
      mat-table
      #tableVehiculos
      [dataSource]="listaLogModel"
      class="table table-striped table-vcenter"
      matSort
    >
      <ng-container matColumnDef="usuario">
        <th mat-header-cell *matHeaderCellDef>Usuario</th>
        <td mat-cell *matCellDef="let element">{{ element.usuario }}</td>
      </ng-container>

      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let element">{{ element.fechaCreacion | date:'dd/MM/yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="comentarios">
        <th mat-header-cell *matHeaderCellDef>Comentarios</th>
        <td mat-cell *matCellDef="let element">{{ element.comentarios }}</td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
  </div>